<pt-sign-header
  [logo]='logo'
  [subtitle]='subtitle'
  [title]='title'>
</pt-sign-header>

<ng-container [ngSwitch]='step'>

  <pt-forgot-password-send-mail
    (clickCancel)='onCancel()'
    (clickConfirm)='onConfirmSendMail($event)'
    *ngSwitchCase='ForgotStep.EMAIL'
    [cancelLabel]='cancelLabel'
    [confirmLabel]='confirmLabel'
    [domainLabel]='domainLabel'
    [domain]='domain'
    [emailLabel]='emailLabel'
    [loading]='loading'>
  </pt-forgot-password-send-mail>

  <pt-forgot-password-update
    (onCancel)='onCancel()'
    (onConfirm)='onConfirmUpdatePassword($event)'
    *ngSwitchCase='ForgotStep.UPDATE_PASSWORD'
    [cancelLabel]='cancelLabel'
    [confirmLabel]='confirmLabel'
    [confirmPasswordLabel]='confirmPasswordLabel'
    [domainLabel]='domainLabel'
    [domain]='domain'
    [emailLabel]='emailLabel'
    [email]='email'
    [loading]='loading'
    [message]="errorMessage"
    [passwordLabel]='passwordLabel'
    [tokenLabel]='tokenLabel'>
  </pt-forgot-password-update>

  <pt-forgot-message
    (onCancel)='onCancel()'
    *ngSwitchCase='ForgotStep.FAILED'
    [cancelLabel]='closeLabel'
    [confirmLabel]='confirmLabel'
    [message]='errorMessage'
    [success]='false'>
  </pt-forgot-message>

  <pt-forgot-message
    (onCancel)='onCancel()'
    *ngSwitchCase='ForgotStep.COMPLETED'
    [cancelLabel]='closeLabel'
    [confirmLabel]='confirmLabel'
    [message]='completeMessage'
    [success]='true'>
  </pt-forgot-message>

</ng-container>
